import { UseFormReturn } from 'react-hook-form';

export const getCommonValidationRules = (_formMethods: UseFormReturn<any>): Record<string, any> => ({
  firstName: { required: 'Ce champ est requis' },
  lastName: { required: 'Ce champ est requis' },
  // Numéro de voie optionnel (SKIP-456, cf. SKIP-370) : beaucoup d'adresses
  // n'en ont pas (lieu-dit, voie sans numérotation, « s/n »). L'ancienne règle
  // l'exigeait sauf en lieu-dit, et lisait `addressType` alors que la modale
  // CTVO nomme le champ `BuyerAddressType` : le numéro y était toujours requis.
  // MiSIV reçoit un <Numero> vide, ce qu'il accepte.
  addressNumber: {},
  addressType: { required: 'Ce champ est requis' },
  addressName: { required: 'Ce champ est requis' },
  city: { required: 'Ce champ est requis' },
  postalCode: { required: 'Ce champ est requis' },
  country: { required: 'Ce champ est requis' },
});

export const getProValidationRules = (formMethods: UseFormReturn<any>): Record<string, any> => ({
  ...getCommonValidationRules(formMethods),
  siret: { required: 'Ce champ est requis' },
  companyName: { required: 'Ce champ est requis' },
});
